import React from 'react';
import PropTypes from 'prop-types';
import Form from './Form';

const Edit = ({
  isModalOpen,
  onCloseHandler,
  onSubmitHandler,
  error,
  submitting,
  badgingBlacklist,
}) => (
  <Form
    isModalOpen={isModalOpen}
    onCloseHandler={onCloseHandler}
    onSubmitHandler={onSubmitHandler}
    error={error}
    submitting={submitting}
    badgingBlacklist={badgingBlacklist}
    action='edit'
  />
);

Edit.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool,
  badgingBlacklist: PropTypes.shape({
    id: PropTypes.string,
    expirationDate: PropTypes.string,
    vin: PropTypes.string,
    sellerNumber: PropTypes.string,
    notes: PropTypes.string,
  }),
};

Edit.defaultProps = {
  isModalOpen: false,
  error: null,
  submitting: false,
  badgingBlacklist: null,
};

export default Edit;
